import React from "react";
import { IconType } from "react-icons";

interface SpecialtyButtonProps extends React.ButtonHTMLAttributes<HTMLButtonElement> {
  icon: React.ReactNode;
  label: string;
  onClick: () => void;
  progress?: number;
  isCompleted?: boolean;
}

export const SpecialtyButton: React.FC<SpecialtyButtonProps> = ({ icon, label, onClick, className, progress = 0, isCompleted = false }) => {
  return (
    <button className={`specialty-button ${isCompleted ? 'completed' : ''} ${className}`} onClick={onClick}>
      {isCompleted && <div className="completion-badge">Done</div>}
      <div className="icon-container">
        {icon}
      </div>
      <span className="label">{label}</span>
      {progress > 0 && !isCompleted && (
        <div className="progress-bar-container">
          <div className="progress-bar-fill" style={{ width: `${progress}%` }}></div>
        </div>
      )}
    </button>
  );
}; 